module.exports = __webpack_public_path__ + "img/scan.8a598a52.svg";